module.exports = __webpack_public_path__ + "img/6.8402c7a9.png";